import { Input } from 'antd';
import React from 'react';
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';

interface Props {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
}

const InputPassword = ({ value, onChange, placeholder }: Props) => {
  return (
    <Input.Password
      autoComplete='off'
      style={{ height: '48px', fontSize: '16px', fontWeight: '500', borderRadius: '4px' }}
      size='large'
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
    />
  );
};

export default InputPassword;
